const CONCEPTS = [
  [/(电影|影片|影视|影院|\bmovies?\b|\bfilms?\b|\bcinema\b)/i, 'movies film cinema video'],
  [/(电视剧|剧集|电视节目|追剧|综艺|短剧|\btv(?:\s+series|\s+shows?)?\b|\bseries\b|\bdramas?\b)/i, 'television series shows drama'],
  [/(动漫|动画|二次元|国漫|萝莉|\banime\b|\bmanga\b|\banimation\b|\bcartoons?\b)/i, 'anime animation cartoons manga'],
  [/(儿童|少儿|孩子|亲子|早教|\bchildren\b|\bkids?\b|\bfamily\b)/i, 'children kids family education'],
  [/(音乐|音频|无损|原声|演唱会|\bmusic\b|\blossless\b|\bsoundtracks?\b|\bconcerts?\b)/i, 'music audio lossless soundtrack concert'],
  [/(有声书|有声小说|广播剧|评书|\baudiobooks?\b|\bspoken audio\b)/i, 'audiobooks spoken audio radio drama'],
  [/(电子书|图书|文学|漫画|\bebooks?\b|\bbooks?\b|\bcomics?\b|\bliterature\b)/i, 'books ebooks literature comics'],
  [/(学习资料|教程|技术学习|\be-?learning\b|\bcourses?\b|\blearning material\b)/i, 'learning education courses tutorials'],
  [/(纪录片|自然|\bdocumentar(?:y|ies)\b|\bnature\b)/i, 'documentary nature'],
  [/(体育|足球|篮球|赛车|F1|MotoGP|奥运|\bsports?\b|\bfootball\b|\bbasketball\b|\bracing\b|\bolympics?\b)/i, 'sports football basketball motorsports racing olympics'],
  [/(游戏|主机|\bgames?\b|\bconsole\b)/i, 'games console gaming'],
  [/(软件|macOS|iOS|Apple|\bsoftware\b|\bapps?\b|\bmac(?:os)?\b)/i, 'software applications apple mac ios'],
  [/(成人|绅士|R18|9Kg|XXX|\badult\b)/i, 'adult content'],
  [/(原盘|蓝光|Blu-?ray|UHD|4K|8K|Remux|\bfull discs?\b|\bdisc archives?\b)/i, 'bluray disc remux ultra high definition full discs'],
  [/(压制|小体积|x265|HEVC|编码|\bencodes?\b|\bcompact\b)/i, 'compact encodes x265 hevc high quality small size'],
  [/(WEB|流媒体|Netflix|追更|\bweb-?dl\b|\bstreaming\b)/i, 'web-dl streaming netflix fast releases'],
  [/(DIY|特效字幕|国语配音|\bstyled subtitles?\b|\bdubbed audio\b)/i, 'custom bluray diy subtitles dubbed'],
  [/(杜比视界|Dolby Vision)/i, 'dolby vision hdr video'],
  [/(杜比全景声|Dolby Atmos)/i, 'dolby atmos immersive audio'],
  [/(母带音频|Hi-?Res audio)/i, 'high resolution master audio'],
  [/(经典黑胶|\bvinyl\b)/i, 'vinyl records music'],
  [/(CD\s*抓轨|CD\s*rips?)/i, 'compact disc audio rips'],
  [/(FANRES|fan restorations?)/i, 'fan restorations fanres'],
  [/(冷门|艺术电影|rare|arthouse)/i, 'rare obscure arthouse films'],
  [/(经典动画|classic animation)/i, 'classic vintage animation'],
  [/(站内发布组|internal release groups?)/i, 'internal release groups'],
  [/(0-Day|zero day)/i, 'zero day fresh releases'],
  [/(无分享率|ratioless)/i, 'ratioless no ratio requirement'],
  [/(开放注册|open signups?|registration open)/i, 'open signup registration access'],
  [/(开放邀请|invites? available)/i, 'invites available access'],
  [/(邀请制|invite only)/i, 'invite only restricted access'],
  [/(适合新手|新手友好|小白福音|beginner[ -]friendly)/i, 'beginner friendly easy economy'],
  [/(论坛|交流|PT\s*community forums?|NAS\s*community)/i, 'forum community discussion nas'],
  [/(高校|校园|教育网|IPv6|university|campus)/i, 'university campus education network ipv6'],
  [/(内站|华语社区|Chinese[- ]language trackers?)/i, 'inner chinese language community trackers'],
  [/(外站|海外社区|international trackers?)/i, 'outer international global trackers'],
  [/(十二大|Top 12 Chinese trackers?)/i, 'top twelve chinese trackers'],
  [/(传统九大|Traditional Nine)/i, 'traditional nine chinese trackers'],
  [/(外站影视三强|Top movie (?:&|and) TV trackers?)/i, 'top international movie television trackers'],
  [/(皮妞堡)/i, 'ptp btn hdb elite trio'],
  [/(韩剧|Korean dramas?)/i, 'korean drama television'],
  [/(日剧|Japanese dramas?)/i, 'japanese drama television'],
  [/(国漫|Chinese animation)/i, 'chinese animation donghua'],
  [/(粤语|Cantonese)/i, 'cantonese chinese audio'],
  [/(法语|法国|French)/i, 'french france'],
  [/(西班牙语|拉美|Spanish|Latin American)/i, 'spanish latin american'],
  [/(罗马尼亚|Romanian)/i, 'romanian romania'],
  [/(俄语|Russian)/i, 'russian'],
  [/(巴西|葡萄牙语|Brazilian|Portuguese)/i, 'brazilian portuguese'],
  [/(Usenet|NZB)/i, 'usenet nzb newznab indexer'],
];

export function expandSemanticText(value) {
  const text = String(value ?? '').trim();
  const keywords = semanticConcepts(text);
  return keywords.length ? `${keywords.join(' ')}. ${text}` : text;
}

export function semanticConcepts(value) {
  const text = String(value ?? '');
  return CONCEPTS.filter(([pattern]) => pattern.test(text)).map(([, expansion]) => expansion);
}
